import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectItem} from 'helpers/hooks/utils';
import StyledFilesList from 'components/organisms/Lists/FilesList/FilesList.styles';
import FileCard from 'components/molecules/Cards/FileCard/FileCard';
import Component from 'components/organisms/Utils/Component/Component';

const FilesList = React.forwardRef((props, ref) => {
  const {
    files,
    Card,
    onClick,
    isLoading,
    loaderCount,
    FileCardProps,
    ...innerProps
  } = useComponentProps({
    loaderCount: 6,
    ...props
  }, 'FilesList');

  const FileCardDefault = ({file, ...props}) => {
    return <FileCard file={file}
                     fullWidth={true}
                     {...props}/>
  };

  const CardMemo = useEffectItem(Card ?? FileCardDefault);
  const renderCard = (file, state) => {
    return <Component Original={CardMemo}
                      file={file}
                      selected={state.selected}
                      onClick={!state.isLoading ? onClick : null}
                      isLoading={state.isLoading}
                      {...FileCardProps} />
  };

  const isItemEqual = (file, selected) => {
    return +file.uploadId === +selected.uploadId;
  }

  return <StyledFilesList ref={ref} {...innerProps}
                          data={files}
                          count={files?.length}
                          dataKey="uploadId"
                          isItemEqual={isItemEqual}
                          renderItem={renderCard}
                          isLoading={isLoading}
                          showProgressBar={false}
                          onFetchMore={null}
                          loaderCount={loaderCount}
                          ListProps={{
                            track: true,
                            virtualize: true,
                            overscan: 1,
                            estimatedSize: 68,
                            gap: 8,
                          }}/>
});

FilesList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  files: PropTypes.array,
  Card: PropTypes.any,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  loaderCount: PropTypes.number,
  FileCardProps: PropTypes.object
};

export default FilesList;
